import { notification } from "antd";
import { ApolloError } from "apollo-boost";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { ChannelInvitationsStore } from "./ChannelInvitationsStore";

export class ChannelInvitationEditStore {
  store: ChannelInvitationsStore;

  visible = false;
  saving = false;
  model?: any;
  communities = [];

  constructor(store: ChannelInvitationsStore) {
    makeAutoObservable(this, {
      store: false,
    });
    this.store = store;
  }

  @action
  async edit({ id, name, code, notes, state, communityId }) {
    this.model = { id, name, code, notes, state, communityId };
    this.visible = true;
    this.loadCommunities();
  }

  @action
  loadCommunities() {
    Api.community.communities({ size: 10000 }).then((res) => {
      runInAction(() => {
        this.communities = res.data.communities.items.filter((x) => x.active);
      });
    });
  }

  @action
  save(values) {
    this.saving = true;
    return Api.invitation
      .saveChannelInvitation({ ...this.model, ...values })
      .then((res) => {
        this.visible = false;
        notification.success({ message: `New app version saved.` });
        this.store.refresh();
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action
  close() {
    this.visible = false;
  }
}
